import * as React from "react"
import styled from "styled-components"
import { ChildrenProps } from "../../@types/@core"
import { colors, scale } from "../../styles"

const SkipLinkStyled = styled.a`
	position: absolute;
	top: -9999px;
	left: -9999px;
	width: 100%;
	height: 1px;
	overflow: hidden;
	text-align: center;
	display: block;
	padding: ${scale.px(1)} ${scale.px(3)};
	background-color: ${colors.blue33};
	color: ${colors.navy};

	&:active,
	&:focus,
	&:hover {
		position: relative;
		left: 0;
		top: 0;
		height: auto;
		overflow: visible;

		> * {
			outline-width: 2px;
			outline-style: solid;
			outline-color: ${colors.alert};
		}
	}
`

const SkipLink: React.FC<ChildrenProps> = (props) => {
	return <SkipLinkStyled href="#main">{props.children}</SkipLinkStyled>
}

export { SkipLink }
